<template>
  <div>
    <Master :pageTitle="pageTitle">
      <template #button>
        <div class="rightBtn">
          <template v-if="authority.isAdmin">
            <a
              class="linkText--text csvSampleStyle font-weight-bold"
              :href="csvSampleUrl"
              target="_blank"
            >
              {{ '※' + $t('common.common_csv-sample') }}
            </a>
            <label class="fileInputLabel">
              {{ $t('common.common_csv-import') }}
              <input
                ref="file"
                type="file"
                class="fileInput"
                @change="fileSelected"
              />
            </label>
          </template>

          <NormalButton
            :text="buttonName"
            height="32px"
            width="96px"
            class="text-right"
            @click="dialogInfo.register = true"
          />
          <MasterCustomerDialog
            v-model="dialogInfo.register"
            @success="registerSuccess"
          />
        </div>
      </template>
      <template #search>
        <CustomerSearch :filter="filter" />
      </template>
      <template #list>
        <div class="customerTable">
          <MasterTable
            :headers="headers"
            :masterItems="getFilterCustomerList"
            :item-key="itemKey"
          >
            <template #isEnabled="{ item }">
              {{ getCustomerStatus(item.isEnabled) }}
            </template>
            <template #customerCategoryName="{ item }">
              {{ getCustomerCategoryName(item.customerCategoryId) || '-' }}
            </template>
            <template #organizationAndSection="{ item }">
              <div class="my-2">
                <div v-if="item.organizationName || item.sectionName">
                  <v-row no-gutters>{{ item.organizationName }} </v-row>
                  <v-row no-gutters>{{ item.sectionName }} </v-row>
                </div>
                <div v-else>{{ '-' }}</div>
              </div>
            </template>
            <template #details="{ item }">
              <div class="my-2">
                <div
                  v-if="
                    item.phoneNumber ||
                    item.mailAddress ||
                    item.wechatId ||
                    item.customerNote ||
                    item.url
                  "
                >
                  <v-row v-if="item.phoneNumber" no-gutters>
                    {{ $t('common.common_tel') + ':' + item.phoneNumber }}
                  </v-row>
                  <v-row v-if="item.mailAddress" no-gutters>
                    {{ $t('common.input_email') + ':' + item.mailAddress }}
                  </v-row>
                  <v-row v-if="item.wechatId" no-gutters>
                    {{ $t('common.input_we-chat-id') + ':' + item.wechatId }}
                  </v-row>
                  <v-row v-if="item.customerNote" no-gutters>
                    {{ $t('common.input_remarks') + ':' + item.customerNote }}
                  </v-row>
                  <v-row v-if="item.url" no-gutters>
                    <a :href="item.url">{{ item.url }} </a>
                  </v-row>
                </div>
                <div v-else>{{ '-' }}</div>
              </div>
            </template>
            <template #billingInfo="{ item }">
              <div class="my-2">
                <div
                  v-if="
                    item.billingOrganizationName ||
                    item.billingSectionName ||
                    item.billingName ||
                    item.billingAddress1 ||
                    item.billingAddress2 ||
                    item.billingPhoneNumber
                  "
                >
                  <v-row v-if="item.billingOrganizationName" no-gutters>
                    {{ item.billingOrganizationName }}
                  </v-row>
                  <v-row
                    v-if="item.billingSectionName || item.billingName"
                    no-gutters
                  >
                    {{
                      (item.billingSectionName || '') +
                      (item.billingName || '') +
                      $t('sale.sale_mr')
                    }}
                  </v-row>
                  <v-row
                    v-if="
                      getRegionName(
                        item.billingAddressCountryId,
                        item.billingRegionId
                      ) || item.billingAddress1
                    "
                    no-gutters
                  >
                    {{
                      (getRegionName(
                        item.billingAddressCountryId,
                        item.billingRegionId
                      ) || '') + (item.billingAddress1 || '')
                    }}
                  </v-row>
                  <v-row v-if="item.billingAddress2" no-gutters>
                    {{ item.billingAddress2 }}
                  </v-row>
                  <v-row v-if="item.billingPhoneNumber" no-gutters>
                    {{
                      $t('common.common_tel') + ':' + item.billingPhoneNumber
                    }}
                  </v-row>
                </div>
                <div v-else>{{ '-' }}</div>
              </div>
            </template>
            <template #edit="{ item }">
              <v-layout>
                <WhiteButton
                  text="common.common_edit"
                  height="32px"
                  width="48px"
                  class="mx-2"
                  @click="edit(item)"
                />
                <div v-if="item.isEnabled" class="mx-auto">
                  <NormalButton
                    :text="$t('表示')"
                    class="mr-2"
                    btnClass="pa-2"
                    height="32px"
                    @click="editIsEnabledToFalse(item)"
                  />
                </div>
                <div v-else class="mx-auto">
                  <NormalButton
                    :text="$t('非表示')"
                    class="mr-2"
                    btnClass="pa-2"
                    height="32px"
                    color="white"
                    textColor="thinText--text"
                    @click="editIsEnabledToTrue(item)"
                  />
                </div>
              </v-layout>
            </template>
          </MasterTable>
        </div>
      </template>
    </Master>
    <MasterCustomerDialog
      v-model="dialogInfo.edit"
      :customerData="customerData"
      :editMode="true"
      @success="editSuccess"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { commonUtil, countryUtil, countryCallingCodeUtil } from '@/util'
import headers from './headers'
import { Master } from '@/components/layouts'
import { NormalButton, WhiteButton, MasterTable } from '@/components/items'
import { MasterCustomerDialog } from '@/components/layouts/Dialogs'
import CustomerSearch from '@/components/layouts/ClientInfo/Customer/CustomerSearch'

export default {
  components: {
    Master,
    MasterCustomerDialog,
    NormalButton,
    WhiteButton,
    MasterTable,
    CustomerSearch
  },
  data: () => {
    return {
      pageTitle: 'common.input_customer-management',
      buttonName: 'sale.sale_customer-registration',
      customerData: {},
      headers: headers.headers,
      itemKey: 'customerId',
      dialogInfo: {
        register: false,
        edit: false
      },
      editMode: false,
      customerCategories: [],
      uploadFile: '',
      filter: {
        customerNumber: '',
        customerName: '',
        alphabet: '',
        customerCategoryId: NaN,
        organizationName: '',
        shopName: '',
        paymentCriteria: '',
        billingName: '',
        payeeInfo: '',
        isEnabled: true
      }
    }
  },
  async created() {
    this.init()
    this.getCustomerCategoryList()
  },
  methods: {
    ...mapActions('Customer', [
      'getCustomersFromApi',
      'editCustomer',
      'fileUpload'
    ]),
    ...mapGetters('Customer', ['getCustomerListFromState']),

    ...mapActions('Common', [
      'getCustomerCategoryListFromApi',
      'getCountryListFromApi']),
    ...mapGetters('Common', [
      'getCustomerCategoryFromState',
      'getCountryCallingCodeJpFromState',
      'getCountryJpFromState'
    ]),

    async init() {
      await this.getCustomersFromApi()
    },
    setCountryCallingCode(countryId) {
      return this.editMode
        ? countryCallingCodeUtil.getPhoneNumberInfoById(countryId)
        : this.getCountryCallingCodeJpFromState()
    },
    setCountryId(countryId) {
      return this.editMode
        ? countryUtil.getCountryIdInfo(countryId)
        : this.getCountryJpFromState()
    },
    async getCustomerCategoryList() {
      await this.getCustomerCategoryListFromApi()
      this.customerCategories = this.getCustomerCategoryFromState()
    },
    getCustomerCategoryName(customerCategoryId) {
      const customerCategory = this.customerCategories.find(
        (element) => element.customerCategoryId === customerCategoryId
      )
      if (customerCategory) {
        return customerCategory.name
      } else {
        return ''
      }
    },
    getRegionName(countryId, regionId) {
      return countryUtil.getRegionInfo(countryId, regionId).label
    },
    getCustomerStatus(isEnabled) {
      if (isEnabled == null) {
        return this.$t('common.common_normal')
      }
      const customerStatus = isEnabled
        ? this.$t('common.common_normal')
        : this.$t('common.common_hide')
      return customerStatus
    },
    edit(customer) {
      this.customerData = { ...customer }
      this.dialogInfo.edit = true
    },
    registerSuccess() {
      this.init()
      this.dialogInfo.register = false
    },
    editSuccess() {
      this.init()
      this.dialogInfo.edit = false
    },
    async editIsEnabledToFalse(item) {
      this.editMode = true
      await this.editCustomer(this.initDataForEditCustomer(item, false))
      item.isEnabled = 0
      this.editMode = false
    },
    async editIsEnabledToTrue(item) {
      this.editMode = true
      await this.editCustomer(this.initDataForEditCustomer(item, true))
      item.isEnabled = 1
      this.editMode = false
    },
    initDataForEditCustomer(item, isEnabled) {
      const formatData = { ...item }
      formatData.phone = {
        countryCode: this.setCountryCallingCode(item.phoneNumberCountryId),
        phoneNumber: item.phoneNumber
      }
      formatData.billingPhone = {
        countryCode: this.setCountryCallingCode(
          item.billingPhoneNumberCountryId
        ),
        phoneNumber: item.billingPhoneNumber
      }
      formatData.billingAddressCountry = this.setCountryId(
        item.billingAddressCountryId
      )
      formatData.billingRegion = countryUtil.getRegionInfo(
        item.billingAddressCountryId,
        item.billingRegionId
      )

      // recipientsをフォーマットした新たな配列を作成
      if (item.recipients) {
        formatData.recipients = item.recipients.map((ele) => {
          return {
            recipientId: ele.recipientId,
            name: ele.name,
            organizationName: ele.organizationName,
            note: ele.note,
            postalCode: ele.postalCode,
            address1: ele.address1,
            address2: ele.address2,
            sortNumber: ele.sortNumber,
            recipientPhone: {
              countryCode: this.setCountryCallingCode(ele.phoneNumberCountryId),
              phoneNumber: ele.phoneNumber
            },
            recipientAddressCountry: this.setCountryId(ele.addressCountryId),
            recipientRegion: countryUtil.getRegionInfo(
              ele.addressCountryId,
              ele.regionId
            )
          }
        })
      }
      const formatRecipientList = formatData.recipients
        ? formatData.recipients.map((ele) => {
            return {
              recipientInfoLine1: {
                recipientName: ele.name,
                recipientOrganizationName: ele.organizationName,
                recipientPhone: ele.recipientPhone,
                recipientSortNumber: ele.sortNumber,
                recipientNote: ele.note
              },
              recipientInfoLine2: {
                country: ele.recipientAddressCountry,
                recipientPostalCode: ele.postalCode,
                recipientRegion: ele.recipientRegion,
                recipientAddress1: ele.address1,
                recipientAddress2: ele.address2
              }
            }
          })
        : []
      return {
        customerId: formatData.customerId,
        id: formatData.customerId,
        neShopId: formatData.neShopId,
        customerInfoLine1: {
          rep: formatData.rep,
          alphabet: formatData.alphabet,
          organizationName: formatData.organizationName,
          sectionName: formatData.sectionName,
          customerCategoryId: formatData.customerCategoryId,
          paymentCriteria: formatData.paymentCriteria,
          rateAccount: formatData.rateAccount,
          autoShipStorageId: formatData.autoShipStorageId,
        },
        customerInfoLine2: {
          phone: formatData.phone,
          mailAddress: formatData.mailAddress,
          wechatId: formatData.wechatId,
          shopName: formatData.shopName,
          url: formatData.url,
          customerNote: formatData.customerNote,
          isEnabled: isEnabled
        },
        invoiceInfoLine1: {
          billingOrganizationName: formatData.billingOrganizationName,
          billingSectionName: formatData.billingSectionName,
          billingName: formatData.billingName,
          billingPhone: formatData.billingPhone
        },
        invoiceInfoLine2: {
          country: formatData.billingAddressCountry,
          billingPostalCode: formatData.billingPostalCode,
          billingRegion: formatData.billingRegion,
          billingAddress1: formatData.billingAddress1,
          billingAddress2: formatData.billingAddress2
        },
        recipientList: formatRecipientList
      }
    },
    async fileSelected(event) {
      this.uploadFile = event.target.files[0]

      const formData = new FormData()
      formData.append('uploadFile', this.uploadFile)
      const uploadData = await this.fileUpload(formData)
      if (uploadData) {
        const nameList = uploadData.data.registeredCustomerList.map((ele) => {
          return ele.organizationName
        })
        const nameListStr = nameList.join(', ')

        alert(`${this.$t('common.common_register-result')}
${nameListStr}
        `)
        this.init()
      }

      this.$refs.file.value = '' // 初期化
    },
    createCustomerCategorySelectBoxValueFrom() {
      if (!this.customerCategories) {
        return
      }
      const result = [
        {
          value: undefined,
          label: ''
        }
      ]
      this.customerCategories.forEach((ele) => {
        result.push({
          value: ele.customerCategoryId,
          label: ele.name
        })
      })
      return result
    }
  },
  computed: {
    ...mapGetters('User', ['authority']),
    csvSampleUrl() {
      let url = ''
      switch (process.env.VUE_APP_ENV_NAME) {
        case 'production':
          url =
            'https://order-assets.spe-s.com/sample/master-upload/customer_upload_sample_20220609.zip'
          break
        case 'staging':
          url =
            'https://stg-order-assets.spe-s.com/sample/master-upload/customer_upload_sample_20220609.zip'
          break
        default:
          url =
            'https://dev-order-assets.spe-s.com/sample/master-upload/customer_upload_sample_20220609.zip'
      }
      return url
    },
    getFilterCustomerList() {
      let customerList = this.getCustomerListFromState()

      // 顧客番号
      const customerNumber = this.filter.customerNumber.replace(/\s+/g, '')
      if (customerNumber !== '') {
        customerList = customerList.filter((customer) => {
          return customer.customerNumber.replace(/\s+/g, '') === customerNumber
        })
      }

      // 顧客名
      const customerName = this.filter.customerName.replace(/\s+/g, '')
      if (customerName !== '') {
        customerList = customerList.filter((customer) => {
          return (
            customer.rep &&
            customer.rep.replace(/\s+/g, '').includes(customerName)
          )
        })
      }

      // アルファベット（ピンイン）
      const alphabet = this.filter.alphabet.replace(/\s+/g, '')
      if (alphabet !== '') {
        customerList = customerList.filter((customer) => {
          return (
            customer.alphabet &&
            customer.alphabet.replace(/\s+/g, '').includes(alphabet)
          )
        })
      }

      // 顧客分類
      const customerCategoryId = this.filter.customerCategoryId
      if (customerCategoryId && !isNaN(customerCategoryId)) {
        customerList = customerList.filter((customer) => {
          return (
            customer.customerCategoryId &&
            customer.customerCategoryId === customerCategoryId
          )
        })
      }

      // 会社名 部署名
      const organizationName = this.filter.organizationName.replace(/\s+/g, '')
      if (organizationName) {
        customerList = customerList.filter((customer) => {
          const targetOrganizationName =
            customer.organizationName + customer.sectionName
          return (
            targetOrganizationName &&
            targetOrganizationName
              .replace(/\s+/g, '')
              .includes(organizationName)
          )
        })
      }

      // 店舗名
      const shopName = this.filter.shopName.replace(/\s+/g, '')
      if (shopName) {
        customerList = customerList.filter((customer) => {
          return (
            customer.shopName &&
            customer.shopName.replace(/\s+/g, '').includes(shopName)
          )
        })
      }

      // 支払条件
      const paymentCriteria = this.filter.paymentCriteria.replace(/\s+/g, '')
      if (paymentCriteria) {
        customerList = customerList.filter((customer) => {
          return (
            customer.paymentCriteria &&
            customer.paymentCriteria.replace(/\s+/g, '') === paymentCriteria
          )
        })
      }

      // 請求書情報
      const filterBillingName = this.filter.billingName.replace(/\s+/g, '')
      if (filterBillingName) {
        customerList = customerList.filter((customer) => {
          customer.billingOrganizationName

          const billingName =
            customer.billingSectionName || customer.billingName
              ? customer.billingSectionName +
                customer.billingName +
                this.$t('sale.sale_mr')
              : ''

          const regionName = countryUtil.getRegionInfo(
            customer.billingAddressCountryId,
            customer.billingRegionId
          ).label
          const address =
            (regionName || customer.billingAddress1 ? regionName : '') +
              customer.billingAddress1 || ''

          const address2 = customer.billingAddress2 || ''

          const billingPhoneNumber = customer.billingPhoneNumber
            ? this.$t('common.common_tel') + ':' + customer.billingPhoneNumber
            : ''

          const displayBillingName =
            (customer.billingOrganizationName || '') +
            billingName +
            address +
            address2 +
            billingPhoneNumber
          return displayBillingName
            .replace(/\s+/g, '')
            .includes(filterBillingName)
        })
      }

      // 受取人情報
      const payeeInfo = this.filter.payeeInfo.replace(/\s+/g, '')
      if (payeeInfo) {
        customerList = customerList.filter((customer) => {
          if (customer.recipients.length === 0) {
            return false
          }
          return customer.recipients.find((recipient) => {
            const address =
              countryUtil.getRegionInfo(
                recipient.addressCountryId,
                recipient.regionId
              ).label +
              commonUtil.getSeparateWordsBySpace([
                recipient.address1,
                recipient.address2
              ])
            const phone = countryCallingCodeUtil.formatPhoneNumber(
              recipient.phoneNumber,
              recipient.phoneNumberCountryId,
              false
            )
            const displayPayeeInfo =
              recipient.name +
              this.$t('sale.sale_mr') +
              (recipient.postalCode ? '〒' + recipient.postalCode : '') +
              address +
              ('TEL' + '： ' + phone)

            return displayPayeeInfo.replace(/\s+/g, '').includes(payeeInfo)
          })
        })
      }

      // 非表示フラグ
      const isEnabledFlg = this.filter.isEnabled
      if (isEnabledFlg) {
        customerList = customerList.filter((customer) => {
          return customer.isEnabled === 1 || customer.isEnabled === null
        })
      }

      return customerList
    }
  }
}
</script>
<style scoped lang="scss">
.customerTable {
  ::v-deep .v-data-table td:last-child {
    padding: 0 8px !important;
  }
}
.rightBtn {
  display: flex;
  justify-content: flex-end;
}
.fileInput {
  display: none;
}
.fileInputLabel {
  width: 108px;
  height: 32px;
  margin: 0px 12px 0px 0px;
  padding: 7px 9px 11px 11px;
  border-radius: 4px;
  border: solid 1px #c8cfd7;
  background-color: #fff;
  font-size: 12px;
  color: #6a6a6a;
}
.csvSampleStyle {
  width: 88px;
  height: 12px;
  margin: 8px 12px 0px 0px;
  font-size: 12px;
  text-decoration: none;
}
.search {
  background-color: #fff;
}
</style>
